import { Box, Button } from "@mui/material"
import React from "react"

interface IInfiniteScrollLoadMore {
  showButton: boolean
  disableButton: boolean
  onButtonPress: () => void
}

export const InfiniteScrollLoadMore = (props: IInfiniteScrollLoadMore) => {
  const { showButton = true, disableButton = false, onButtonPress } = props
  return (
    <Box
      display="flex"
      pt={[1, 2, 2]}
      pb={[5, 5, 2]}
      mx={["auto"]}
      my="0"
      flexDirection="column"
      width={["100%", "60%", "400px"]}
      alignItems="center"
      minHeight="100px">
      {showButton && (
        <Button
          variant="contained"
          color="primary"
          style={{ width: "100%" }}
          disabled={disableButton}
          onClick={onButtonPress}>
          Load More
        </Button>
      )}
    </Box>
  )
}
